import { render, staticRenderFns } from "./BasicElementsSection.vue?vue&type=template&id=6ae7dd91&scoped=true&"
import script from "./BasicElementsSection.vue?vue&type=script&lang=js&"
export * from "./BasicElementsSection.vue?vue&type=script&lang=js&"
import style0 from "./BasicElementsSection.vue?vue&type=style&index=0&id=6ae7dd91&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae7dd91",
  null
  
)

export default component.exports